if (!customElements.get('swiper-image-gallery')) {
  class Gallery extends HTMLElement {
    constructor() {
      super();
      this.startingIndex = this.dataset.startingIndex;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.thumbs = this.querySelector('[data-thumbs]');

      this.gallery = this.querySelector('[data-gallery]');
      this.gallery.addEventListener('swiperslidechangetransitionend', (e) => {
        setTimeout(() => {
          this.querySelector('[data-pagination]').innerHTML = `${(e.detail[0]?.realIndex + 1)} / ${e.detail[0]?.slides.length}`;
        }, 10);
      });
      this.gallery.addEventListener('click', () => this.gallery.swiper.zoom.toggle());
    }
  }
  
  customElements.define('swiper-image-gallery', Gallery);
}